import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { SyntheticEvent } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type CategoryLinkProps = {
    superCategoryUrl: string;
    superCategoryName: string;
    className?: string;
};

const CategoryLink = ({
    superCategoryUrl,
    superCategoryName,
    className
}: CategoryLinkProps) => {
    const { t } = useGranite();

    if (!superCategoryName || !superCategoryUrl) return null;

    const handleOnCategoryLinkClick = (event: SyntheticEvent) => {
        event.stopPropagation();
        event.preventDefault();
        window.location.href = superCategoryUrl;
    };

    return (
        <div className={className}>
            <Button
                type={"button"}
                color={"link"}
                onClick={handleOnCategoryLinkClick}
                className={cn(
                    "tw:px-0 tw:py-2 tw:w-full tw:flex tw:no-underline tw:items-center"
                )}
            >
                <span
                    className={cn(
                        "tw:overflow-hidden tw:text-ellipsis tw:break-all tw:text-sm tw:text-left tw:whitespace-normal",
                        "tw:hover:underline"
                    )}
                >
                    {t("productTile.category.link", superCategoryName)}
                </span>
                <i className={cn("las la-angle-right", "tw:text-sm")} />
            </Button>
        </div>
    );
};

export default CategoryLink;
